export default __webpack_public_path__ + "static/media/STP.5eda992b.svg";